import { authHeader, cleanQueryParams, handleResponse } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// All Limited Releases List
function getTargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/groups`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getTargetGroupsByFuse(params) {
  const cleanedParams = cleanQueryParams(params);
  const query = new URLSearchParams(cleanedParams).toString();
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  // const { fuseSn } = queryParams;
  const endPoint = `/api/admin/v1/groups/fuse?${query}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getFuseTargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/fuses/limited/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getHm5TargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/hm5/limited/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}
function getHmplusTargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/hmplus/limited/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getUATargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/ua/limited/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getSaTargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/sa/limited/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}
function getVs2jen2TargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/vs2jen2/limited/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getVs2ngaTargetGroups() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/vs2nga/limited/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const TargetGroupService = {
  getTargetGroups,
  getTargetGroupsByFuse,
  getFuseTargetGroups,
  getHm5TargetGroups,
  getSaTargetGroups,
  getVs2jen2TargetGroups,
  getUATargetGroups,
  getVs2ngaTargetGroups,
  getHmplusTargetGroups,
};
